// extracted by mini-css-extract-plugin
export var copyableField = "_s8-4";
export var customerBadge = "_s8-0";
export var customerInfoTitle = "_s8-2";
export var details = "_s8-1";
export var dropdownContainer = "_s8-5";
export var dropdownImage = "_s8-6";
export var editAssigneeForm = "_s8-a";
export var editButton = "_s8-3";
export var email = "_s8-7";
export var hidden = "_s8-d";
export var input = "_s8-8";
export var saveButton = "_s8-b";
export var shopifyIcon = "_s8-c";
export var suggestionBadge = "_s8-e";
export var suggestionText = "_s8-f";
export var username = "_s8-9";